import { TenantResolveGuard } from './app-guards/tenant.resolver';
import { PaginaNaoEncontradaComponent } from './pagina-nao-encontrada/pagina-nao-encontrada.component';
import { NgModule } from '@angular/core';
import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AutenticacaoGuard } from './app-guards/autenticacao.guard';

const appRoutes: Routes = [
  {path: '404', component: PaginaNaoEncontradaComponent},
  {
    path: 'login',
    loadChildren: 'app/autenticacao/autenticacao.module#AutenticacaoModule'
  },
  {
    path: ':tenantCodigo/login',
    loadChildren: 'app/autenticacao/autenticacao.module#AutenticacaoModule'
  },
  {
    path: ':tenantCodigo/excluir-conta',
    loadChildren: 'app/excluir-conta/autenticacao.module#AutenticacaoModule'
  },
  {
    path: '',
    loadChildren: 'app/inicio/inicio.module#InicioModule',
    canActivate: [AutenticacaoGuard]
  },
  {
    path: 'midia',
    loadChildren: 'app/midia/midia.module#MidiaModule',
    canActivate: [AutenticacaoGuard]
  },
  {
    path: ':tenantCodigo',
    loadChildren: 'app/inicio/inicio.module#InicioModule',

    canActivate: [AutenticacaoGuard],
    resolve: { tenant : TenantResolveGuard }
  },
  {path: '**', redirectTo: '/404'}

];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts